import React from 'react';
import { FlexibleCRUDTable } from '../../components/common/FlexibleCRUDTable';
import { DynamicForm } from '../../components/common/DynamicForm';
import { abacUserAttributeEntity } from '../../config/entities/abacUserAttributes';
import { abacUserAttributeService } from '../../services/abac';
import { toast } from 'react-hot-toast';
import { useLanguage } from '../../state/language/LanguageProvider';

const UserAttributesPage: React.FC = () => {
  const [showForm, setShowForm] = React.useState(false);
  const [editingItem, setEditingItem] = React.useState<any>(null);
  const { t } = useLanguage();

  const handleCreate = () => {
    setEditingItem(null);
    setShowForm(true);
  };

  const handleEdit = (item: any) => {
    setEditingItem(item);
    setShowForm(true);
  };

  const handleToggleStatus = async (id: string, isActive: boolean) => {
    try {
      await abacUserAttributeService.toggleStatus(id, isActive);
      toast.success(t('abac.userAttributeStatusUpdated'));
    } catch (error) {
      toast.error(t('abac.failedToUpdateUserAttributeStatus'));
    }
  };

  const handleDelete = async (item: any) => {
    try {
      await abacUserAttributeService.delete(item.id);
      toast.success(t('abac.userAttributeDeleted'));
    } catch (error) {
      toast.error(t('abac.failedToDeleteUserAttribute'));
    }
  };

  const handleFormSubmit = async (data: any) => {
            console.log('Data keys:', Object.keys(data || {}));
    
    try {
      if (editingItem) {
        await abacUserAttributeService.update(editingItem.id, data);
        toast.success(t('abac.userAttributeUpdated'));
      } else {
        await abacUserAttributeService.create(data);
        toast.success(t('abac.userAttributeCreated'));
      }
      setShowForm(false);
      setEditingItem(null);
    } catch (error) {
      console.error('Form submission error:', error);
      toast.error(t('abac.failedToSaveUserAttribute'));
    }
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditingItem(null);
  };

  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">{t('abac.userAttributesManagement')}</h1>
        <p className="text-gray-600 mt-2">
          {t('abac.defineAndManageUserAttributes')}
        </p>
      </div>

      {showForm ? (
        <DynamicForm
          entity={abacUserAttributeEntity}
          initialData={editingItem}
          onSubmit={handleFormSubmit}
          onCancel={handleFormCancel}
        />
      ) : (
        <FlexibleCRUDTable
          entity={abacUserAttributeEntity}
          service={abacUserAttributeService}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onToggleStatus={handleToggleStatus}
          onCreate={handleCreate}
          onOperationComplete={() => {
            // This will be called after successful operations (create, update, delete)
            // The table will automatically refresh via loadData() in the component
          }}
        />
      )}
    </div>
  );
};

export default UserAttributesPage;
